import {Component, OnDestroy, OnInit, OnChanges, ViewEncapsulation} from '@angular/core';
import bodymovin from 'bodymovin/build/player/bodymovin_light.min.js';
import {Utilities} from '@shared/utilities/utilities.model';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
    selector: 'amd-not-found-page',
    templateUrl: './not-found-page.component.html',
    styleUrls: ['./not-found-page.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class NotFoundPageComponent implements OnInit, OnChanges, OnDestroy {

    private animation: any;
    private animation2: any;
    translateContext: TranslateContext = TranslateContext.SHARED;

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.loadErrorAnimation();
        this.loadErrorAnimationClear();
    }

    ngOnChanges() {

    }

	ngOnDestroy(): void {
		if (!Utilities.isVoid(this.animation)) {
			this.animation.stop();
			this.animation = null;
		}
        if (!Utilities.isVoid(this.animation2)) {
            this.animation2.stop();
            this.animation2 = null;
        }
	}

    private loadErrorAnimation() {

        const elementId = 'errorAnimationId';

        const animationParams = {
            container: document.getElementById(elementId),
            renderer: 'svg',
            loop: false,
            autoplay: true,
            path: '/assets/404.animation.json'
        };

        this.animation = bodymovin.loadAnimation(animationParams);
        this.animation.play();
    }

    private loadErrorAnimationClear() {

        const elementId = 'errorAnimationId-clear';

        const animationParamsClear = {
            container: document.getElementById(elementId),
            renderer: 'svg',
            loop: false,
            autoplay: true,
            path: '/assets/404.animation-clear.json'
        };

        this.animation2 = bodymovin.loadAnimation(animationParamsClear);
        this.animation2.play();
    }
}
